import { forwardRef } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  InputAdornment,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  Investors,
  setBalanceDialog,
} from "../../../../app/slices/investorsSlice";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const InitialSupplierBalanceForm = () => {
  const _InitialSupplierBalance = useSelector(
    (state) => state.investors.balance
  );
  const _SearchBody = useSelector((state) => state.investors.searchBody);

  const { control, handleSubmit } = useForm({
    defaultValues: _InitialSupplierBalance.form,
  });

  const onSubmit = (data) => {
    if (_InitialSupplierBalance.type === "deposit") {
      dispatch(
        Investors.deposit(
          _InitialSupplierBalance.investor_id,
          {
            amount: data.amount,
          },
          _SearchBody
        )
      );
    } else {
      dispatch(
        Investors.withdraw(
          _InitialSupplierBalance.investor_id,
          {
            amount: data.amount,
          },
          _SearchBody
        )
      );
    }
  };

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setBalanceDialog({
      id: null,
      type: null,
    }));
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <Dialog
      open={_InitialSupplierBalance.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {_InitialSupplierBalance.type === "deposit" ? "اضافة رصيد" : "سحب رصيد"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="amount"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="المبلغ"
                    fullWidth
                    {...field}
                    InputProps={{
                      inputComponent: NumericFormatCustom,
                      startAdornment: (
                        <InputAdornment position="start">IQD</InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default InitialSupplierBalanceForm;
